import React, { useEffect, useMemo, useState } from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import { H3 } from "../Text";
const OptionHeaderItem = styled.div `
  background-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  border-bottom: 4px solid transparent;
  margin: 0;

  h3 {
    cursor: pointer;
  }

  ${({ isSelected }) => isSelected
    ? css `
          border-bottom: 4px solid ${Colors.LIGHT_RED_2024};
          font-weight: bold !important;
        `
    : css `
          h3 {
            font-weight: normal;
          }
        `}
`;
const InputWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${Colors.LIGHT_RED_2024};
`;
export const OptionHeader = ({ options, "data-cy": testId, onClick, }) => {
    const [selectedId, setSelectedId] = useState(options.find((o) => o.isSelected)?.id);
    const currentOptions = useMemo(() => options.map((option) => {
        if (option.id === selectedId && option.isSelected === false) {
            option.onClick(option.id);
        }
        return { ...option, isSelected: option.id === selectedId };
    }), [options, selectedId]);
    useEffect(() => {
        if (options &&
            options.filter((opt) => opt.id === selectedId).length === 0) {
            setSelectedId(options[0].id);
        }
    }, [options, selectedId]);
    return (React.createElement(InputWrapper, { className: "option-header" }, currentOptions.map((option) => (React.createElement(OptionHeaderItem, { className: `option-header-item-${option.id} ${option.isSelected ? "selected" : ""}`, key: option.id, isSelected: option.isSelected, "data-cy": testId != null
            ? `${testId}-${option.title
                .replace(" ", "")
                .replace("/", "")
                .toLowerCase()}`
            : undefined },
        React.createElement(H3, { onClick: () => {
                setSelectedId(option.id);
                if (onClick && selectedId !== option.id) {
                    setTimeout(() => {
                        onClick(option.id);
                    }, 50);
                }
            } }, option.title))))));
};
export default OptionHeader;
//# sourceMappingURL=OptionHeader.js.map